import styled from 'styled-components';
import { mediaQueryMobileMin } from 'styleUtils';
export var Arrow = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-149se3q-0"
})(["width:0;height:0;position:absolute;left:0;top:0;right:0;border:5px solid transparent;"]);
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-149se3q-1"
})(["background:rgba(17,21,18,0.9);border-radius:2px;color:#fff;font-size:12px;line-height:16px;height:auto;left:", ";min-width:", ";opacity:1;padding:8px;position:fixed;top:", ";visibility:", ";width:", ";z-index:1003;text-align:center;box-shadow:0 4px 8px rgba(0,0,0,0.14);@media ", "{min-width:", ";width:", ";}", " ", "{", "}"], function (_ref) {
  var left = _ref.left;
  return "".concat(left, "px");
}, function (_ref2) {
  var width = _ref2.width;
  return width ? "".concat(width, "px") : '265px';
}, function (_ref3) {
  var top = _ref3.top;
  return "".concat(top, "px");
}, function (_ref4) {
  var show = _ref4.show;
  return show ? 'visible' : 'hidden';
}, function (_ref5) {
  var width = _ref5.width;
  return width ? "".concat(width, "px") : '265px';
}, mediaQueryMobileMin, function (_ref6) {
  var width = _ref6.width;
  return width ? "".concat(width, "px") : '265px';
}, function (_ref7) {
  var width = _ref7.width;
  return width ? "".concat(width, "px") : '265px';
}, function (_ref8) {
  var fixedPosition = _ref8.fixedPosition;

  if (fixedPosition) {
    return "\n        position: absolute;\n        top: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n      ";
  }

  return '';
}, Arrow, function (_ref9) {
  var position = _ref9.position,
      arrowOffset = _ref9.arrowOffset;

  if (position === 'top') {
    return "\n            transform: translateX(-50%);\n            top: auto;\n            bottom: -5px;\n            left: ".concat(arrowOffset ? "".concat(arrowOffset, "%") : '50%', ";\n            border-bottom: none;\n            border-top-color: rgba(0, 0, 0, 0.9);\n          ");
  }

  if (position === 'bottom') {
    return "\n            transform: translateX(-50%);\n            top: -5px;\n            bottom: auto;\n            left: ".concat(arrowOffset ? "".concat(arrowOffset, "%") : '50%', ";\n            border-top: none;\n            border-bottom-color: rgba(0, 0, 0, 0.9);\n          ");
  }

  if (position === 'left') {
    return "\n            transform: translateY(-50%);\n            right: -5px;\n            left: auto;\n            top: ".concat(arrowOffset ? "".concat(arrowOffset, "%") : '50%', ";\n            border-right: none;\n            border-left-color: rgba(0, 0, 0, 0.9);\n          ");
  }

  if (position === 'right') {
    return "\n            transform: translateY(-50%);\n            left: -5px;\n            right: auto;\n            top: ".concat(arrowOffset ? "".concat(arrowOffset, "%") : '50%', ";\n            border-left: none;\n            border-right-color: rgba(0, 0, 0, 0.9);\n          ");
  }

  return '';
});